/**
 * @generated SignedSource<<b1db13b8e08fac21723f1876a1deb72e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TemplateCardSmallNoteTemplate$data = {
  readonly summary: string;
  readonly title: string;
  readonly " $fragmentType": "TemplateCardSmallNoteTemplate";
};
export type TemplateCardSmallNoteTemplate$key = {
  readonly " $data"?: TemplateCardSmallNoteTemplate$data;
  readonly " $fragmentSpreads": FragmentRefs<"TemplateCardSmallNoteTemplate">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TemplateCardSmallNoteTemplate",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "summary",
      "storageKey": null
    }
  ],
  "type": "NoteTemplateNode",
  "abstractKey": null
};

(node as any).hash = "d854a8bc3a7bf861c7ad0443e86aeb3c";

export default node;
